import React, { Component } from 'react'
import { logoutService } from '../../../services/aws/aws-services';
import ActiveDirectoryUserComponent from './ActiveDirectoryUser';

export default class ActiveDirectoryUser extends Component {
	/**
	 * @description Function to handle logout
	 * @memberof UnauthorizedUser
	 */
	handleLogout = () => {
		logoutService((err, res) => { });
	}

	render() {
		return (
			<ActiveDirectoryUserComponent handleLogout={this.handleLogout} />
		)
	}
}